import React from 'react';
import Banner from '../components/Banner/Banner';
import bannerImage from '../assets/banner.jpg';
import LogoHorizontalWhite from '../assets/logo-horizontal-white-only.svg';
import LogoVerticalWhite from '../assets/logo-vertical-white.svg';

const UnderConstructionPage: React.FC = () => {
  return (
    <div>
      <Banner imageUrl={bannerImage} isGrayscale isFullHeight>
        <div className="flex flex-col items-center justify-center max-w-[900px] m-auto px-4">
          <img
            src={LogoHorizontalWhite}
            alt="Logo-horizontal-white"
            width={900}
            className="hidden md:block"
          />
          <div className="md:hidden px-6 flex flex-col items-center justify-center">
            <img src={LogoVerticalWhite} alt="Logo-vertical-white" width={400} />
          </div>
        </div>
      </Banner>
    </div>
  );
};

export default UnderConstructionPage;
